// test1934
(1934 && 0);
